/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef } from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import { Progress } from 'antd';
import { useQuery } from '../../hooks/useQuery';
import { ReactComponent as SelectedSub } from './img/sub-cat-selected.svg';
import { ReactComponent as FilledSub } from './img/sub-cat-filled.svg';
import { ReactComponent as UnselectedSub } from './img/sub-cat-unselected.svg';
import { ReactComponent as CatSelected } from './img/cat-selected.svg';

const CategoryItem = ({ t, name, selected, category, selectedIndex, validateCategory }) => {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const hasAutoSelected = useRef(false);

  const { onboardingById } = useSelector(state => state.onboardingReducer);
  const currentIndex = category?.group_order-1;

  const query = useQuery(search);
  const subCategory = query.get('sub-category');

  const handleSelectSubCategory = (e, id) => {
    e.stopPropagation();
    const newQuery = new URLSearchParams(search);
    newQuery.set('sub-category', id);
    history.replace({
      pathname,
      search: `?${newQuery.toString()}`,
    });
  };

  useEffect(() => {
    if (!selected) {
      hasAutoSelected.current = false;
    }
  }, [selected]);

  useEffect(() => {
    if (selected && !subCategory && category && category?.subCategory?.length > 0 && !hasAutoSelected.current) {
      hasAutoSelected.current = true;
      const newQuery = new URLSearchParams(search);
      newQuery.set('sub-category', category?.subCategory[0].id);
      history.replace({
        pathname,
        search: `?${newQuery.toString()}`,
      });
    }
    
  }, [selected, subCategory, category, search, pathname, history]);

  const getTotalElements = useMemo(() => {
    let filled = 0;
    let total = 0;
    let subFilled = {};
    return {filled, total};
  }, [category, onboardingById]);

  const getFilledStatus = (id) => {
    const element =  validateCategory?.subCategory?.find( i => i.id === id);
    const result = element?.mandatory === element?.filledMandatory ? 'completed' : '';
    console.log('🚀 ~ getFilledStatus ~ result:', result);
    return result;
  };

  return (
    <>
      <div className={selected ? 'category-item selected' : 'category-item'}>
        <div className="category-colunm">
          <div
            className={
              `category-checkbx ${currentIndex === selectedIndex ? 'full' : ''}${validateCategory?.filledMandatory === validateCategory?.mandatory ? ' completed' : ''}`}
          />
          <p className="category-name">{t(name)}</p>
        </div>
        <div className="category-counter-wrapper">
          <div className="category-counter">
            <span className='category-counter-filled'>{validateCategory?.filled}</span><span style={{fontSize: '20px', lineHeight: '24px'}}>/</span>
            <span className='category-counter-total'>{validateCategory?.total}</span>
          </div>
          {selected && <CatSelected />}
        </div>
        <Progress 
            className='table-date-progress'
            percent={getTotalElements?.total > 0 
              ?( getTotalElements?.filled * 100 / getTotalElements?.total).toFixed(2) 
              : 0} 
            showInfo={false} 
            strokeColor={'#FB7B34'}
            size={{height: 2}}
          />
      </div>
      {selected && category?.subCategory?.length > 0 &&
        category?.subCategory?.map((i) => (
          <div
            className={`category-sub-item ${subCategory === i.id ? 'selected' : ''}`}
            key={i.id}
            onClick={(e) => handleSelectSubCategory(e, i.id)}
          >
            <div className='category-sub-item-title'>
              {getFilledStatus(i?.id) === 'completed' 
                ? <FilledSub /> 
                : subCategory === i.id 
                  ? <SelectedSub /> 
                  : <UnselectedSub />
                }
              <p>{i.description}</p>
            </div>
            <div className="category-counter">
              <span className='category-counter-filled'>{getTotalElements?.subFilled[i?.id] || 0}</span><span style={{fontSize: '20px', lineHeight: '24px'}}>/</span>
              <span className='category-counter-total'>{i?.form_elements?.filter(element => element?.form_action_element?.type !== 'GENERAL').length || 0}</span>
            </div>
          </div>
        ))}
    </>
  );
};

export default CategoryItem;

CategoryItem.propTypes = {
  t: PropTypes.func,
  category: PropTypes.object,
  name: PropTypes.string,
  selectedIndex: PropTypes.number,
  selected: PropTypes.bool,
  validateCategory: PropTypes.object,
};
